































import { Vue, Component, Prop } from "vue-property-decorator";
import { TaskModel } from "@/store/models/TaskListModel";
import tasks from "@/store/modules/tasks";

@Component
export default class Task extends Vue {
  @Prop() task!: TaskModel;
  @Prop() columnOrder!: number;
  @Prop() taskOrder!: number;

  editTaskId: string | null = null;
  editTaskText: string | null = null;
  deletingTask = false;

  removeTask() {
    this.deletingTask = true;
    setTimeout(() => {
      tasks.removeTask({ columnOrder: this.columnOrder, taskOrder: this.taskOrder });
    }, 300);
  }

  closeEditTaskInput() {
    this.editTaskText = null;
    this.editTaskId = null;
  }

  handleEditTask() {
    if (this.editTaskId && this.editTaskText)
      tasks.editTask({ columnOrder: this.columnOrder, taskId: this.editTaskId, text: this.editTaskText });
    this.closeEditTaskInput();
  }

  toggleFavourite() {
    tasks.toggleFavourite({ columnOrder: this.columnOrder, taskOrder: this.taskOrder });
  }
}
